var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "phone",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25304",
    "data-name": "Path 25304",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25305",
    "data-name": "Path 25305",
    d: "M5.118,4H9.353l2.118,5.294L8.824,10.882a11.647,11.647,0,0,0,5.294,5.294l1.588-2.647L21,15.647v4.235A2.118,2.118,0,0,1,18.882,22,16.941,16.941,0,0,1,3,6.118,2.118,2.118,0,0,1,5.118,4",
    transform: "translate(0 -1)",
    fill: "#1d1d26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.d83be67e7f650de551bf16937fda0e03.svg";
export { ForwardRef as ReactComponent };